import React, { Fragment } from 'react'
import NavBar from '../../../../components/NavBar'
import UserHeader from '../../Headers/UserHeader'
import AddAdminUser from './AddAdminUser'

function IndexAdminUser(props) {
  return (
   <Fragment>
    <NavBar {...props}/>
    <AddAdminUser
    {...props}
    />
   </Fragment>
  )
}

export default IndexAdminUser